export class ImageCropperModel {
    public fileName: string;
    public processingWidth: number;
    public processingHeight: number;
    public dimensionX1: number;
    public dimensionX2: number;
    public dimensionY1: number;
    public dimensionY2: number;
}
